import type { DocumentData, Timestamp } from "firebase/firestore";

import type { IMeddreamHourlyMetric } from "../schemas/meddream-hourly";

function toDate(value: unknown): Date | undefined {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  if (typeof value === "object" && value !== null && "toDate" in value) {
    const ts = value as Timestamp;
    return ts.toDate();
  }
  if (typeof value === "number") return new Date(value);
  if (typeof value === "string") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? undefined : d;
  }
  return undefined;
}

function num(value: unknown, fallback = 0): number {
  return typeof value === "number" && Number.isFinite(value) ? value : fallback;
}

/**
 * Mapea un documento Firestore a modelo UI.
 * Excluye `sessionIds` (pesado / no exponer).
 */
export function mapMeddreamHourlyDoc(
  id: string,
  data: DocumentData
): IMeddreamHourlyMetric {
  const hourStart =
    toDate(data.hourStart) ??
    (typeof data.hourStartMs === "number" ? new Date(data.hourStartMs) : new Date(0));

  const updatedAt = toDate(data.updatedAt);

  return {
    id,
    hourKey: typeof data.hourKey === "string" ? data.hourKey : `${id}:00:00Z`,
    hourStart,
    hourStartMs: num(data.hourStartMs, hourStart.getTime()),
    year: num(data.year),
    month: num(data.month),
    day: num(data.day),
    hour: num(data.hour),
    date: typeof data.date === "string" ? data.date : id.slice(0, 10),
    yearMonth: typeof data.yearMonth === "string" ? data.yearMonth : id.slice(0, 7),
    activeConnectionsMax: num(data.activeConnectionsMax),
    activeConnectionsMin: num(data.activeConnectionsMin),
    activeConnectionsAvg: num(data.activeConnectionsAvg),
    samplesCount: num(data.samplesCount),
    uniqueSessionsCount: num(data.uniqueSessionsCount),
    restartsCount: num(data.restartsCount),
    sourceFile: typeof data.sourceFile === "string" ? data.sourceFile : undefined,
    updatedAt,
    connectionSum:
      typeof data.connectionSum === "number" ? data.connectionSum : undefined,
  };
}
